import React, { useEffect, useState } from "react";
import UlpsPortalApiClient from "../UlpsPortalApiClient";
import { Alert, Spinner } from "react-bootstrap";

export default function Users() {
  const [users, setUsers] = useState(null);
  const [isWaiting, setWaiting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    setWaiting(true);
    UlpsPortalApiClient.getUsers()
      .then(response => {
        setWaiting(false);
        setUsers(response.data); // <-- set only the array
      })
      .catch(err => {
        setWaiting(false);
        setErrorMessage(err.message);
      });
  }, []);

  if (isWaiting) {
    return (
      <>
        <br/><br/>
        <Spinner animation="border"/>
      </>
    );
  } else if (!users) {
    return (
      <>
        <br/><br/>
        <Alert variant={"danger"}>
          Unable to fetch users. {errorMessage}
        </Alert>
      </>
    );
  }

  // Table columns
  const columns = [
    { key: "id", label: "ID" },
    { key: "name", label: "Name" },
    { key: "email", label: "E-mail" },
    { key: "isAdmin", label: "Admin" },
    { key: "isDelivery", label: "Delivery" },
    { key: "isSupport", label: "Support" },
    { key: "distributorId", label: "Distributor ID" },
    { key: "createdAt", label: "Created At" },
    { key: "updatedAt", label: "Updated At" },
    { key: "disabledAt", label: "Disabled At" },
  ];

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="container">
        <h2 className="text-center mb-4">Users</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-hover">
            <thead className="thead-dark">
              <tr>
                {columns.map(col => (
                  <th key={col.key}>{col.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(users.data || users).map(user => (
                <tr key={user.id} className={user.disabledAt ? "table-danger" : "table-success"}>
                  {columns.map(col => (
                    <td key={col.key}>
                      {typeof user[col.key] === "boolean"
                        ? (user[col.key] ? "✔️" : "")
                        : user[col.key] === null
                          ? "-"
                          : user[col.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
